//react
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

//UI
import { message, Row, Col } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { CardElement } from "../../../../components/Common/UIElements";
import {
  ButtonPrimary,
  Button,
} from "../../../../components/Common/Button/index";
import PropertyDetailsForm from "../../../../components/Onboarding/PropertyDetailsForm/PropertyDetailsForm";

//processing
import { onboardingPropertyEditSchema } from "../../../../schema/onboarding-properties.schema";
import { simpleStringDecode } from "../../../../utils/common-utils";
import useQuery from "../../../../hooks/url.hooks";
import {
  useGetPropertyById,
  useUpdateProperty,
} from "../../../../hooks/Onboarding/onboarding-properties.hooks";

const PropContactPropertyEditor = () => {
  const history = useHistory();

  //get customer from url
  let query = useQuery();
  const propertyId = simpleStringDecode(query.get("property"));

  //fetch customer properties (Hotels)
  const { data: apiPropertyData } = useGetPropertyById(propertyId, {
    enabled: !!propertyId,
    select: (data) => {
      return {
        ...data,
        property_contact: {
          _id: data?.property_contact_id?._id,
          first_name: data?.property_contact_id?.first_name,
          last_name: data?.property_contact_id?.last_name,
          email: data?.property_contact_id?.email,
        },
      };
    },
  });

  const { handleSubmit, control, formState, reset } = useForm({
    mode: "onChange",
    resolver: yupResolver(onboardingPropertyEditSchema),
  });

  useEffect(() => {
    if (apiPropertyData) {
      reset({
        ...apiPropertyData,
      });
    }
  }, [apiPropertyData]);

  //approve/update hooks
  const { mutateAsync: updateProperty } = useUpdateProperty({
    onSuccess: () => {
      history.push(
        "/onboarding/dashboard?msg=Property details updated successfully",
      );
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const savePropertyDetails = (formData) => {
    console.log("Property form data ::", formData);
    updateProperty(formData);
  };

  const clickCancel = () => {
    history.push("/onboarding/dashboard");
  };

  return (
    <>
      <CardElement title="System Discovery">
        <Row>
          <Col span={1} offset={23}>
            <div onClick={clickCancel}>
              <CloseOutlined />
            </div>
          </Col>
        </Row>
        <Row>
          <PropertyDetailsForm
            control={control}
            errors={formState.errors}
            disableStatus
          />
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              style={{ width: "150px" }}
              htmlType="button"
              onClick={clickCancel}
            >
              Cancel
            </Button>
            <ButtonPrimary
              style={{ width: "150px" }}
              onClick={handleSubmit(savePropertyDetails)}
            >
              Save
            </ButtonPrimary>
          </Col>
        </Row>
      </CardElement>
    </>
  );
};

export default PropContactPropertyEditor;
